/**
 * Validação cliente/contrato ao arrastar OS de Em aberto para técnico no Board.
 */

import { getApiBaseUrl } from '../../../utils/apiConfig';

export const BOARD_DRAG_MSG_CLIENTE =
  'Atenção, o cliente está inativo ou suspenso. Consulte o setor responsável para as devidas ações.';
export const BOARD_DRAG_MSG_CONTRATO =
  'Atenção, o contrato está inativo ou suspenso. Consulte o setor responsável para as devidas ações.';

/**
 * @param {string[]} orderIds
 * @returns {Promise<{ blocked: boolean, messages: string[] }>}
 */
export async function validateBoardDragClienteContrato(orderIds) {
  const ids = Array.isArray(orderIds)
    ? orderIds.map((x) => String(x || '').trim()).filter(Boolean)
    : [];
  if (ids.length === 0) {
    return { blocked: false, messages: [] };
  }
  const token = localStorage.getItem('authToken');
  try {
    const res = await fetch(`${getApiBaseUrl()}/api/board/orders/validate-cliente-contrato`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orderIds: ids }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      return { blocked: false, messages: [] };
    }
    return {
      blocked: Boolean(data.blocked),
      messages: Array.isArray(data.messages) ? data.messages : [],
    };
  } catch (_err) {
    return { blocked: false, messages: [] };
  }
}
